export const WEATHER_API_URL = "https://api.open-meteo.com/v1/forecast";
export const POSITION_STACK_API_URL = "https://api.positionstack.com/v1/";
export const POSITION_STACK_API_KEY = process.env.POSITION_STACK_API_KEY;
export const UNSPLASH_API_KEY = process.env.UNSPLASH_API_KEY;
export const DEFAULT_LATITUDE = 36.1716; // Default latitude for Las Vegas
export const DEFAULT_LONGITUDE = -115.1391; // Default longitude for Las Vegas
